import Vue from "vue";
import ListSfPlaceRepository from "@/repositories/monocle/ListSfPlaceRepository";

export interface MonoclePlace {
    uuid: string;
    label: string;
}

export default {
    state: {
        places: [],
    },
    mutations: {
        setMonoclePlaces: (
            state: any,
            places: MonoclePlace[]
        ) => {
            Vue.set(state, "places", places);
        },
    },
    getters: {
        getMonoclePlaces: (state: any): MonoclePlace[] => {
            return state.places;
        },
    },
    actions: {
        loadMonoclePlaces: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                const orders = { default: "DESC", label: "ASC" };
                const params = { orders };
                ListSfPlaceRepository.get(params).then((data: any) => {
                    commit("setMonoclePlaces", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
